import Header from "../navigation/header";
import {
  StyleSheet,
  TouchableOpacity,
  TextInput as TextInputRn,
  Modal,
  Button,
  ScrollView,
  FlatList,
  Switch,
  Dimensions,
} from "react-native";
import { TextInput } from "react-native-paper";

import { Text, View } from "../../../components/Themed";
import { RootStackScreenProps } from "../../../types"; // @ts-ignore
// import { DataTable } from "react-native-paper";
// import { Provider as PaperProvider } from "react-native-paper";
import DataTable from "react-data-table-component";

import Icon from "react-native-vector-icons/AntDesign";
import React, { useEffect, useState, useMemo, useRef } from "react";
import IconCross from "react-native-vector-icons/Entypo";
import { baseUrl, postData } from "../../../networking/api";
import IconEdit from "react-native-vector-icons/FontAwesome";
import IconEye from "react-native-vector-icons/Entypo";
import { useFocusEffect } from "@react-navigation/native";
import SuccessPopup from "../../../components/SuccessPopup";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ActivityIndicator } from "react-native";

export default function ProjectType() {
  var [counter, setCounter] = useState(1);
  const [searchData, setSearch] = useState("");
  const [filterData, setFilteredDataSource] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  var alpha_pattern = new RegExp(/^[a-zA-Z]+(\s[a-zA-Z]+)?$/);
  const [isEnabled, setIsEnabled] = useState(false);

  const [error, setError] = useState("");
  const [ProjectTypeNameData, setProjectTypeNameData] = useState([]);
  const [ProjectTypeByName, setProjectTypeByName] = useState("");
  const [ProjectTypeId, setProjectTypeId] = useState(false);
  const [projectTypeLength, setProjectTypeLength] = useState(0);
  const [isAdd, setisAdd] = useState(false);
  const [sort, setsort] = useState(0);
  const [editpopup, setEditPopup] = useState(false);
  const [popid, setpopid] = useState("");
  const [popindex, setpopindex] = useState("");
  const [issuccessVisible, setissuccessVisible] = useState(false);
  const [responsestatus, setresponsestatus] = useState("");
  const [PopupMessage, setPopupMessage] = useState("");
  const [ProjectValue, setProjectValue] = useState("");

  // DATATABLE PROJECT TYPE COLUMN AND STYLE
  const customStyles = {
    rows: {
      style: {
        // maxWidth: 50,
        minHeight: "30px", // override the row height
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        backgroundColor: "#319ef0a3",
        minHeight: "40px",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    headCells: {
      style: {
        // paddingLeft: '8px', // override the cell padding for head cells
        // paddingRight: '8px',
        justifyContent: "center",
        minHeight: "20px",

        // borderRightWidth: 2,
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          // fontSize: 16,
          // fontWeight: '600',
          // borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", // override the cell padding for data cells
        paddingRight: "8px",
        justifyContent: "center",

        "&:not(:last-of-type)": {
          textTransform: "Capitalize",
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          fontSize: 16,
          fontWeight: "400",
          // borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
  };
  const caseInsensitiveSort = (rowA, rowB) => {
    const a = rowA.type.toLowerCase();
    const b = rowB.type.toLowerCase();

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };
  const columns = [
    {
      name: "Sr.No",
      selector: (row) => row.index,
      //cell: (row, index) => index + 1,

      // sortable: true,
      width: "100px",
    },
    {
      name: "Project Type",
      selector: "type",
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },
    {
      name: "Value",
      selector: "value",
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },
    {
      name: "Action",
      width: "100px",

      // selector: "country",

      // sortable: true
      cell: (item) => (
        <TouchableOpacity
          onPress={() => isAddable(item.id, item.type, item.value)}
        >
          <IconEdit
            name="pencil"
            size={13}
            color="#fff"
            style={{
              padding: 6,
              backgroundColor: "#08588E",
              borderRadius: 12,
            }}
          />
        </TouchableOpacity>
      ),
    },
    {
      name: "Status",
      width: "100px",

      cell: (item, index) => (
        <Switch
          trackColor={{ false: "#767577", true: "#1DA1F2" }}
          thumbColor={item.active == 1 ? "#fff" : "#f4f3f4"}
          activeThumbColor="#fff"
          onValueChange={() => {
            setEditPopup(true);
            setpopid(item.id);
            setpopindex(index);
          }}
          value={item.active == 1 ? true : false}
        />
      ),
    },
  ];
  const toggleSwitch = () => {
    var tempIndex = ProjectTypeNameData.findIndex((item) => item.id === popid);

    if (ProjectTypeNameData[tempIndex].active == 1) {
      ProjectTypeNameData[tempIndex].active = 0;
      activeProjectType(popid, 0);
    } else {
      ProjectTypeNameData[tempIndex].active = 1;
      activeProjectType(popid, 1);
    }
    setProjectTypeNameData(ProjectTypeNameData);
  };
  //Pagination
  const optionsPerPage = [10, 25, 50, 100];

  const [page, setPage] = React.useState(0);
  const [itemsPerPage, setItemsPerPage] = React.useState(optionsPerPage[0]);
  const from = page * itemsPerPage;
  const to = Math.min((page + 1) * itemsPerPage, projectTypeLength);
  React.useEffect(() => {
    setPage(0);
    setpopindex("");
    setEditPopup(false);
    setpopid("");
  }, [itemsPerPage]);

  useFocusEffect(
    React.useCallback(() => {
      getProjectTypeList([]);
      searchFilterFunction("");
    }, []),
  );
  const textProjectType = useRef("");
  const [isLoading, setIsLoading] = useState(true);

  const textToProjectType = (text) => {
    textProjectType.current = text.nativeEvent.text;
    // setProjectTypeByName(text.nativeEvent.text);
  };

  const showProjectType = () => {
    return textProjectType.current;
  };
  const searchFilterFunction = (text) => {
    // Check if searched text is not blank
    if (text) {
      // Inserted text is not blank
      // Filter the masterDataSource
      // Update FilteredDataSource
      const newData = ProjectTypeNameData.filter(function (item) {
        const itemData = item.type ? item.type.toUpperCase() : "".toUpperCase();
        const textData = text.toUpperCase();
        return itemData.indexOf(textData) > -1;
      });
      setFilteredDataSource(newData);
      setSearch(text);
      setPage(0);
    } else {
      // Inserted text is blank
      // Update FilteredDataSource with masterDataSource
      setFilteredDataSource(ProjectTypeNameData);
      setSearch(text);
      setPage(0);
    }
  };
  const CheckEnteredData = async () => {
    var projectTypes =
      showProjectType() !== "" ? showProjectType() : ProjectTypeByName;

    //setProjectType(projectTypes);
    if (projectTypes == "") {
      // //alert("pls enter");
      setError("Please enter Project Type");
      // setIsVisible(false);
    } else if (alpha_pattern.test(projectTypes)) {
      {
        isAdd == true && createProjectType(projectTypes);
        setIsVisible(false);
      }

      {
        isAdd == false && updateProjectType(projectTypes);
        setIsVisible(false);
      }
    } else {
      // //alert("only character:", projectTypes);
      setError("Please enter Character only");
      // setIsVisible(false);
    }

    // navigation.replace('DrawerNavigation');
  };

  //Project Type create API
  const createProjectType = async (projectTypes) => {
    setIsLoading(true);
    try {
      var projectTypeData = JSON.stringify({
        module: "project_type",
        data: {
          type: projectTypes,
          value: ProjectValue,
          active: 1,
        },
      });
      const projectTypeResponse = await postData(
        projectTypeData,
        "masters/masterCreateUpdate",
      );

      setIsLoading(false);

      var code = projectTypeResponse.code;
      if (code == 1) {
        setPopupMessage("Record Created Successfully");
        setissuccessVisible(true);
        setresponsestatus("success");
        setIsVisible(false);
        getProjectTypeList([]);
        setProjectTypeByName("");
        textProjectType.current = "";
      } else {
        setIsLoading(false);
        setissuccessVisible(true);
        setresponsestatus("failed");
        setPopupMessage(projectTypeResponse.message);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  //isActive Project Type
  const activeProjectType = async (projectTypeId, isActive) => {
    setIsLoading(true);
    try {
      var countryData = JSON.stringify({
        id: projectTypeId,
        module: "project_type",
        data: {
          active: isActive,
        },
      });
      const activeProjectTypeResponse = await postData(
        countryData,
        "masters/masterCreateUpdate",
      );

      setIsLoading(false);

      var code = activeProjectTypeResponse.code;
      if (code == 1) {
        // //alert(activeProjectTypeResponse.message);
        setIsVisible(false);
        getProjectTypeList([]);
      } else {
        setIsLoading(false);
        // //alert(activeProjectTypeResponse.message);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  //project type Update API
  const updateProjectType = async (ProjectTypeNameData) => {
    setIsLoading(true);
    try {
      var ProjectTypeData = JSON.stringify({
        id: ProjectTypeId,
        module: "project_type",
        data: {
          type: ProjectTypeNameData,
          value: ProjectValue,
          active: 1,
        },
      });
      const ProjectTypeResponse = await postData(
        ProjectTypeData,
        "masters/masterCreateUpdate",
      );

      setIsLoading(false);

      var code = ProjectTypeResponse.code;
      if (code == 1) {
        setPopupMessage("Record Updated Successfully");
        setissuccessVisible(true);
        setresponsestatus("success");
        setIsVisible(false);
        getProjectTypeList([]);
      } else {
        setIsLoading(false);
        setissuccessVisible(true);
        setresponsestatus("failed");
        setPopupMessage(ProjectTypeResponse.message);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  // project type Get Api
  const getProjectTypeList = async (sortdata: never[]) => {
    setIsLoading(true);
    if (sortdata.length > 0) {
      setProjectTypeLength(sortdata.length);
      setProjectTypeNameData(sortdata);
      setFilteredDataSource(sortdata);
    } else {
      try {
        var ProjectTypeData = JSON.stringify({
          module: "project_type",
          relation: [],
        });
        const ProjectTypeList = await postData(
          ProjectTypeData,
          "masters/getMasterList",
        );
        setIsLoading(false);
        var code = ProjectTypeList.code;
        if (code == 1) {
          setProjectTypeLength(ProjectTypeList.data.length);
          setProjectTypeNameData(ProjectTypeList.data);
          setFilteredDataSource(ProjectTypeList.data);
        } else {
          setIsLoading(false);
          //alert(ProjectTypeList.message);
        }
      } catch (error) {
        setIsLoading(false);
      }
    }
  };

  const isCreatable = () => {
    setIsVisible(true);
    setisAdd(true);
  };
  const isAddable = (projectypeId, project_type_name, value) => {
    setIsVisible(true);

    setisAdd(false);
    setProjectTypeByName(project_type_name);
    setProjectValue(value);
    //textProjectType.current = project_type_name;
    setProjectTypeId(projectypeId);
  };

  function ProjectTypeModal() {
    // const [isVisible, setIsVisible] = useState(false);

    return (
      <>
        <Modal
          onRequestClose={() => setIsVisible(false)}
          transparent
          visible={isVisible}
        >
          {" "}
          <View
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
              backgroundColor: "rgba(100,100,100, 0.5)",
            }}
          >
            <View
              style={
                isMobile
                  ? {
                      // alignItems: "center",
                      backgroundColor: "white",
                      borderColor: "#eee",
                      borderRadius: 10,
                      borderWidth: 1,
                      // justifyContent: "center",
                      height: "auto",
                      margin: "auto",
                      padding: 30,
                      shadowOffset: {
                        width: 0,
                        height: 2,
                      },
                      shadowOpacity: 0.25,
                      shadowRadius: 4,
                      elevation: 5,
                      // marginRight: 10,
                      // marginRight: 1,
                      width: "80%",
                    }
                  : [styles.containeralt]
              }
            >
              <TouchableOpacity
                style={{ alignSelf: "flex-end" }}
                onPress={() => setIsVisible(false)}
              >
                <IconCross
                  name="circle-with-cross"
                  size={20}
                  color="#000"
                  style={{ bottom: 5, top: 10 }}
                />
              </TouchableOpacity>
              <View style={{ width: "100%" }}>
                <Text style={{ fontWeight: "600" }}>Project Type </Text>
                {isAdd == true && (
                  <TextInputRn
                    style={styles.input}
                    placeholder=""
                    autoFocus={true}
                    onChange={textToProjectType}
                  />
                )}

                {isAdd == false && (
                  <TextInputRn
                    style={styles.input}
                    placeholder=""
                    value={ProjectTypeByName}
                    key="Edit"
                    autoFocus
                    onChangeText={(text) => {
                      setProjectTypeByName(text);
                    }}
                  />
                )}
                <Text style={[styles.error_text]}>{error}</Text>
              </View>
              <View style={{ width: "100%" }}>
                <Text style={{ fontWeight: "600" }}>Value </Text>
                {isAdd == true && (
                  <TextInputRn
                    style={styles.input}
                    placeholder=""
                    autoFocus={true}
                    onChange={textToProjectType}
                  />
                )}

                {isAdd == false && (
                  <TextInputRn
                    style={styles.input}
                    placeholder=""
                    value={ProjectValue}
                    key="Edit"
                    autoFocus
                    onChangeText={(text) => {
                      setProjectValue(text);
                    }}
                  />
                )}
                <Text style={[styles.error_text]}>{error}</Text>
              </View>
              {isAdd == true && (
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-evenly",
                    marginHorizontal: 20,
                  }}
                >
                  <TouchableOpacity
                    style={styles.saveBtn}
                    onPress={() => CheckEnteredData()}
                  >
                    <Text style={styles.btnText}>Save</Text>
                  </TouchableOpacity>

                  <TouchableOpacity
                    style={styles.saveBtn}
                    onPress={() => {
                      (setIsVisible(false), setError(""));
                    }}
                  >
                    <Text style={styles.btnText}>Cancel</Text>
                  </TouchableOpacity>
                </View>
              )}
              {isAdd == false && (
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-evenly",
                    marginHorizontal: 20,
                  }}
                >
                  <TouchableOpacity
                    style={styles.saveBtn}
                    onPress={() => CheckEnteredData()}
                  >
                    <Text style={styles.btnText}>Update</Text>
                  </TouchableOpacity>

                  <TouchableOpacity
                    style={styles.saveBtn}
                    onPress={() => setIsVisible(false)}
                  >
                    <Text style={styles.btnText}>Cancel</Text>
                  </TouchableOpacity>
                </View>
              )}

          
            </View>
          </View>
        </Modal>
      </>
    );
  }
  const sortFun = () => {
    const sortData = filterData.sort((item, b) =>
      sort == 1
        ? item.type.localeCompare(b.type)
        : b.type.localeCompare(item.type),
    );
    getProjectTypeList(sortData);
    setFilteredDataSource(sortData);
  };

  const downloadExcelReport = async () => {
    const filteredData = ProjectTypeNameData.map(({ type, active }, index) => ({
      "Sr No": index + 1,
      "Project Type": type,
      Active: active == 1 ? "Active" : "InActive",
    }));
    // const filteredData = ProjectTypeNameData.map(({ createdAt, updatedAt, index, ...rest }) => rest);
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      type: "array",
      bookType: "xlsx",
    });
    const excelData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(excelData, "project_type_master.xlsx");
  };
  const screenwidth = Dimensions.get("window").width;
  const isMobile = screenwidth < 768;
  return (
    <View style={styles.container}>
      <ProjectTypeModal />
      <SuccessPopup
        visible={issuccessVisible}
        PopupMessage={PopupMessage}
        Responsestatus={responsestatus}
        onChange={() => setissuccessVisible(false)}
      />

      <Modal
        visible={editpopup}
        animationType={"slide"}
        transparent={true}
        onRequestClose={() => {
          setEditPopup(false);
        }}
      >
        <View
          style={
            isMobile
              ? {
                  // alignItems: "center",
                  backgroundColor: "white",
                  borderColor: "#eee",
                  borderRadius: 10,
                  borderWidth: 1,
                  // justifyContent: "center",
                  height: "auto",
                  margin: "auto",
                  padding: 30,
                  shadowOffset: {
                    width: 0,
                    height: 2,
                  },
                  shadowOpacity: 0.25,
                  shadowRadius: 4,
                  elevation: 5,
                  // marginRight: 10,
                  // marginRight: 1,
                  width: "80%",
                }
              : [styles.contanerSwitch]
          }
        >
          <TouchableOpacity
            style={{ alignSelf: "flex-end" }}
            onPress={() => setEditPopup(false)}
          >
            <IconCross
              name="circle-with-cross"
              size={20}
              color="#000"
              style={{ bottom: 5, top: 0 }}
            />
          </TouchableOpacity>

          <Text style={[styles.tableHead, { marginBottom: 20 }]}>
            Do You Want Update Status
          </Text>
          <View
            style={{
              flexDirection: "row",
              paddingRight: 10,
              justifyContent: "space-between",
            }}
          >
            <TouchableOpacity
              onPress={() => {
                (setEditPopup(false), toggleSwitch());
              }}
              style={styles.saveBtn}
            >
              <Text style={{ color: "white" }}>Yes</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                setEditPopup(false);
              }}
              style={styles.saveBtn}
            >
              <Text style={{ color: "white" }}>No</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
      <View
        style={
          isMobile
            ? { width: "100%", marginTop: 180 }
            : { flexDirection: "row", width: "100%", marginTop: "10%" }
        }
      >
        <View style={{ flex: 1, margin: 10 }}>
          <Text style={styles.lableText}>Master {">"} Project Type</Text>
        </View>
        <View
          style={
            isMobile
              ? {
                  alignItems: "center",
                  marginTop: 20,
                  marginLeft: "-35%",
                  width: "170%",
                  flex: 2,
                }
              : { alignItems: "center", flex: 2 }
          }
        >
          <TextInput
            style={
              isMobile
                ? {
                    height: 35,
                    borderWidth: 2,
                    paddingLeft: 10,
                    borderColor: "#319ef0",
                    backgroundColor: "#FFFFFF",
                    width: "50%",
                    borderRadius: 5,
                    color: "#000",
                    fontWeight: "400",
                  }
                : styles.textInputStyle
            }
            onChangeText={(text) => searchFilterFunction(text)}
            value={searchData}
            underlineColorAndroid="transparent"
            placeholder="Search Project type"
            underlineColor={"white"}
            theme={{
              colors: {
                text: "black",
                primary: "white",
                background: "transparent",
              },
            }}
            left={
              <TextInput.Icon
                name={() => <IconEdit name="search" size={20} color="#000" />} // where <Icon /> is any component from vector-icons or anything else
              />
            }
          />
        </View>
        <View style={{ flex: 1, alignItems: "flex-end" }}>
          <TouchableOpacity
            style={
              isMobile
                ? {
                    alignItems: "center",
                    backgroundColor: "#006EB9",
                    padding: 10,
                    borderWidth: 1,
                    borderColor: "#006EB9",
                    width: "53%",
                    // marginTop: 20,
                  }
                : styles.addProjTypeBtn
            }
            onPress={() => {
              (isCreatable(), setError(""));
            }}
          >
            <Text style={styles.btnText}>
              <Icon name="plus" size={15} color="#fff" /> Add Project Type
            </Text>
          </TouchableOpacity>
        </View>
      </View>

      <View
        style={
          isMobile
            ? {
                width: "100%",
                alignItems: "flex-end",
                marginTop: "-10%",
                marginLeft: "-120%",
              }
            : { width: "100%", alignItems: "flex-end" }
        }
      >
        <TouchableOpacity
          style={
            isMobile
              ? [styles.addCountry, { width: "45%", marginRight: -10 }]
              : [styles.addCountry, { width: "10%" }]
          }
          onPress={() => {
            downloadExcelReport();
          }}
        >
          <Text style={styles.btnText}>
            <Icon name="exclefile1" size={15} color="#fff" /> Download
          </Text>
        </TouchableOpacity>
      </View>
     
      <View
        style={
          isMobile
            ? [styles.card, { flexGrow: 1, marginTop: 50, paddingBottom: 10 }]
            : [styles.card, { flexGrow: 1 }]
        }
      >
        <View
          style={[
            styles.shadowProp,
            {
              backgroundColor: "white",
              borderRadius: 8,
              // paddingVertical: 45,
              // paddingHorizontal: 25,
            },
          ]}
        >
          <View
            style={{
              width: "100%",
              // flex: 1,
              backgroundColor: "#F6F9F9",
              borderRadius: 8,
              // paddingVertical: 45,
              // paddingHorizontal: 100,
            }}
          >
            <View
              style={
                isMobile
                  ? {
                      borderWidth: 1,
                      borderColor: "#e3e0e0",
                      width: "240%",
                      alignSelf: "center",
                    }
                  : {
                      borderWidth: 1,
                      borderColor: "#e3e0e0",
                      borderRadius: 2,
                    }
              }
            >
              <View>
                {isLoading ? (
                  <ActivityIndicator
                    color="#1DA1F2"
                    visible={isLoading}
                    textContent={"Loading..."}
                    size={80}
                  />
                ) : (
                  <DataTable
                    // title="State"
                    columns={columns}
                    data={filterData}
                    customStyles={customStyles}
                    pagination
                  />
                )}
              </View>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    // marginTop: 300,
  },
  textInputStyle: {
    height: 35,
    borderWidth: 2,
    paddingLeft: 20,
    borderColor: "#319ef0",
    backgroundColor: "#FFFFFF",
    width: "40%",
    fontWeight: "400",
  },
  containeralt: {
    // alignItems: "center",
    backgroundColor: "white",
    borderColor: "#eee",
    borderRadius: 10,
    borderWidth: 1,
    // justifyContent: "center",
    height: "auto",
    margin: "auto",
    padding: 30,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    // marginRight: 10,
    // marginRight: 1,
    width: "30%",
  },
  input: {
    borderColor: "gray",
    width: "100%",
    borderWidth: 1,
    borderRadius: 2,
    padding: 10,
    marginTop: 20,
    marginBottom: 5,
  },
  tableHead: {
    fontSize: 14,
    /* FontFamily: 'Muli' ,*/
    fontWeight: "700",
    color: "#000000",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  addProjTypeBtn: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "60%",
    // marginTop: 20,
  },
  saveBtn: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "50%",
    marginRight: 10,
  },
  contanerSwitch: {
    backgroundColor: "white",
    borderColor: "#eee",
    borderRadius: 5,
    alignSelf: "center",
    borderWidth: 1,
    // justifyContent: "center",
    height: "25%",
    margin: "auto",
    padding: 10,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    // marginRight: 10,
    // marginRight: 1,
    width: "30%",
  },
  tableHeader: {
    color: "#000",
    fontSize: 14,
    /* FontFamily: 'Muli' ,*/
    fontWeight: "400",
  },
  btnText: {
    color: "#fff",
    fontWeight: "600",
  },
  lableText: {
    color: "#484848",
    fontWeight: "700",
    marginTop: 18,
    // fontSize: 21,
  },
  card: {
    width: "40%",
    flex: 1,
    marginVertical: 10,
  },
  shadowProp: {
    shadowColor: "#171717",
    shadowOffset: { width: -2, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 25,
  },
  error_text: {
    color: "red",
    fontSize: 14,
    fontWeight: "600",
    width: "70%",
    marginLeft: 0,
    marginBottom: 20,
  },

  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
  linkText: {
    fontSize: 14,
    color: "#2e78b7",
  },
  addCountry: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "50%",
    // marginTop: 20,
  },
});
